import React, {useCallback, useEffect, useState} from 'react';
import _ from "lodash";
import Checkbox from "../../../../../components/checkbox";
import {useList} from "react-use";
import  lodash from 'lodash';

import {Collapse} from 'react-collapse';

const getNumCheck = (value) => {
    let i = 0;
    lodash.filter(value,item => {
        if(item.check) i++;
    })
    return i;
}
function Count(props) {
    const [isOpened, setIsOpened] = useState(false);
    const {selected} = props;
    const [oneStrike] = useList([
        {
            id: '00',
            name: '0-0',
            check: false,
        },
        {
            id: '10',
            name: '1-0',
            check: false,
        },
        {
            id: '20',
            name: '2-0',
            check: false,
        },
        {
            id: '30',
            name: '3-0',
            check: false,
        },
    ])
    const [twoStrike] = useList([
        {
            id: '01',
            name: '0-1',
            check: false,
        }, {
            id: '11',
            name: '1-1',
            check: false,
        }, {
            id: '21',
            name: '2-1',
            check: false,
        }, {
            id: '31',
            name: '3-1',
            check: false,
        },
    ])
    const [threeStrike] = useList([
        {
            id: '02',
            name: '0-2',
            check: false,
        }, {
            id: '12',
            name: '1-2',
            check: false,
        }, {
            id: '22',
            name: '2-2',
            check: false,
        }, {
            id: '32',
            name: '3-2',
            check: false,
        }
    ])
    const [totalCondition, setTotalCondition] = useState({
        oneStrike: selected.oneStrike,
        twoStrike: selected.twoStrike,
        threeStrike: selected.threeStrike,
    })
    const [isCheckTotalOne, setIsCheckTotalOne] = useState(false);
    const [isCheckTotalTwo, setIsCheckTotalTwo] = useState(false);
    const [isCheckTotalThird, setIsCheckTotalThird] = useState(false);

    useEffect(() => {
        if (selected.oneStrike.length > 0) {
            selected.oneStrike.map(item => {
                const index = oneStrike.findIndex(i => i.id === item);
                oneStrike[index].check = true;
            })
            if (selected.oneStrike.length === oneStrike.length) setIsCheckTotalOne(true);
        }
        if (selected.twoStrike.length > 0) {
            selected.twoStrike.map(item => {
                const index = twoStrike.findIndex(i => i.id === item);
                twoStrike[index].check = true;
            })
            if (selected.twoStrike.length === twoStrike.length) setIsCheckTotalTwo(true);
        }
        if (selected.threeStrike.length > 0) {
            selected.threeStrike.map(item => {
                const index = threeStrike.findIndex(i => i.id === item);
                threeStrike[index].check = true;
            })
            if (selected.threeStrike.length === threeStrike.length) setIsCheckTotalThird(true);
        }
    }, [selected])
    useEffect(() => {
        props.onChange(totalCondition)
    }, [totalCondition])
    useEffect(() => {
        if (_.isEmpty(totalCondition.oneStrike)) {
            setIsCheckTotalOne(false);
            return;
        }
        if(totalCondition.oneStrike.length !== getNumCheck(totalCondition.oneStrike)) setIsCheckTotalOne(false);
    }, [totalCondition.oneStrike])
    useEffect(() => {
        if (_.isEmpty(totalCondition.twoStrike)) {
            setIsCheckTotalTwo(false);
            return;
        }
        if(totalCondition.twoStrike.length !== getNumCheck(totalCondition.twoStrike)) setIsCheckTotalTwo(false);

    }, [totalCondition.twoStrike])
    useEffect(() => {
        if (_.isEmpty(totalCondition.threeStrike)) {
            setIsCheckTotalThird(false);
            return;
        }
        if(totalCondition.threeStrike.length !== getNumCheck(totalCondition.threeStrike)) setIsCheckTotalThird(false);

    }, [totalCondition.threeStrike])

    const onClickTotalOne = useCallback(() => {
        setIsCheckTotalOne(!isCheckTotalOne);
        if (!isCheckTotalOne) {
            const arr = [];
            const cpList = [...oneStrike];
            cpList.forEach(i => {
                arr.push(i.id);
                i.check = true
            })
            setTotalCondition(state => ({...state, oneStrike: arr}))
        } else {
            const cpList = [...oneStrike];
            cpList.forEach(i => {
                i.check = false
            })
            setTotalCondition(state => ({...state, oneStrike: []}))
        }

    }, [isCheckTotalOne])

    const onCheckOne = useCallback((val) => {
        const arr = [...totalCondition.oneStrike];
        const cpList = [...oneStrike];

        const index = _.indexOf(arr, val);
        const i = _.findIndex(cpList, item => item.id === val)
        if (index === -1) {
            arr.push(val);
            cpList[i].check = true;
        } else {
            arr.splice(index, 1);
            cpList[i].check = false;
        }
        setTotalCondition(state => ({...state, oneStrike: arr}));
    })
    const onClickTotalTwo = useCallback(() => {
        setIsCheckTotalTwo(!isCheckTotalTwo);
        if (!isCheckTotalTwo) {
            const arr = [];
            const cpList = [...twoStrike];
            cpList.forEach(i => {
                arr.push(i.id);
                i.check = true
            })
            setTotalCondition(state => ({...state, twoStrike: arr}))
        } else {
            const cpList = [...twoStrike];
            cpList.forEach(i => {
                i.check = false
            })
            setTotalCondition(state => ({...state, twoStrike: []}))
        }

    }, [isCheckTotalTwo])

    const onCheckTwo = useCallback((val) => {
        const arr = [...totalCondition.twoStrike];
        const cpList = [...twoStrike];

        const index = _.indexOf(arr, val);
        const i = _.findIndex(cpList, item => item.id === val)
        if (index === -1) {
            arr.push(val);
            cpList[i].check = true;
        } else {
            arr.splice(index, 1);
            cpList[i].check = false;
        }
        setTotalCondition(state => ({...state, twoStrike: arr}));
    })
    const onClickTotalThird = useCallback(() => {
        setIsCheckTotalThird(!isCheckTotalThird);
        if (!isCheckTotalThird) {
            const arr = [];
            const cpList = [...threeStrike];
            cpList.forEach(i => {
                arr.push(i.id);
                i.check = true
            })
            setTotalCondition(state => ({...state, threeStrike: arr}))
        } else {
            const cpList = [...threeStrike];
            cpList.forEach(i => {
                i.check = false
            })
            setTotalCondition(state => ({...state, threeStrike: []}))
        }

    }, [isCheckTotalThird])

    const onCheckThird = useCallback((val) => {
        const arr = [...totalCondition.threeStrike];
        const cpList = [...threeStrike];

        const index = _.indexOf(arr, val);
        const i = _.findIndex(cpList, item => item.id === val)
        if (index === -1) {
            arr.push(val);
            cpList[i].check = true;
        } else {
            arr.splice(index, 1);
            cpList[i].check = false;
        }
        setTotalCondition(state => ({...state, threeStrike: arr}));
    })
    return (
        <div className='group-filter-item'>
           <div className={'open-collapse'}>
               <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                   <h4>カウント</h4>
                   <img src="/img/chevron_down_24px.svg" alt="arrow-down" style={{transform:isOpened === true && 'rotate(180deg)'}}/>
               </div>

               <Collapse isOpened={isOpened}>
                   <div>
                       <div className='search-main-advanced-checkbox'>
                           <label>
                               <Checkbox checked={isCheckTotalOne} onClick={onClickTotalOne}/>
                               0ストライク
                           </label>
                       </div>
                       <div className='search-main-analysis-child-item' style={{ display: 'flex', marginLeft: 10}}>
                           {oneStrike.map(item => {
                               return (
                                   <div key={item.id} className='search-main-advanced-checkbox'>
                                       <label>
                                           <Checkbox checked={item.check} onClick={() => onCheckOne(item.id)}/>
                                           {item.name}
                                       </label>
                                   </div>
                               )
                           })}
                       </div>
                       <div className='search-main-advanced-checkbox'>
                           <label>
                               <Checkbox checked={isCheckTotalTwo} onClick={onClickTotalTwo}/>
                               1ストライク
                           </label>
                       </div>
                       <div className='search-main-analysis-child-item' style={{ display: 'flex', marginLeft: 10}}>
                           {twoStrike.map(item => {
                               return (
                                   <div key={item.id} className='search-main-advanced-checkbox'>
                                       <label>
                                           <Checkbox checked={item.check} onClick={() => onCheckTwo(item.id)}/>
                                           {item.name}
                                       </label>
                                   </div>
                               )
                           })}
                       </div>
                       <div className='search-main-advanced-checkbox'>
                           <label>
                               <Checkbox checked={isCheckTotalThird} onClick={onClickTotalThird}/>
                               2ストライク
                           </label>
                       </div>
                       <div className='search-main-analysis-child-item' style={{ display: 'flex', marginLeft: 10}}>
                           {threeStrike.map(item => {
                               return (
                                   <div key={item.id} className='search-main-advanced-checkbox'>
                                       <label>
                                           <Checkbox checked={item.check} onClick={() => onCheckThird(item.id)}/>
                                           {item.name}
                                       </label>
                                   </div>
                               )
                           })}
                       </div>
                   </div>
               </Collapse>
           </div>
            <div className={'close-collapse'}>
                <div>
                    <h4>カウント</h4>
                </div>
                    <div>
                        <div className='search-main-advanced-checkbox'>
                            <label>
                                <Checkbox checked={isCheckTotalOne} onClick={onClickTotalOne}/>
                                0ストライク
                            </label>
                        </div>
                        <div className='search-main-analysis-child-item' style={{ display: 'flex', marginLeft: 10}}>
                            {oneStrike.map(item => {
                                return (
                                    <div key={item.id} className='search-main-advanced-checkbox'>
                                        <label>
                                            <Checkbox checked={item.check} onClick={() => onCheckOne(item.id)}/>
                                            {item.name}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                        <div className='search-main-advanced-checkbox'>
                            <label>
                                <Checkbox checked={isCheckTotalTwo} onClick={onClickTotalTwo}/>
                                1ストライク
                            </label>
                        </div>
                        <div className='search-main-analysis-child-item' style={{ display: 'flex', marginLeft: 10}}>
                            {twoStrike.map(item => {
                                return (
                                    <div key={item.id} className='search-main-advanced-checkbox'>
                                        <label>
                                            <Checkbox checked={item.check} onClick={() => onCheckTwo(item.id)}/>
                                            {item.name}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                        <div className='search-main-advanced-checkbox'>
                            <label>
                                <Checkbox checked={isCheckTotalThird} onClick={onClickTotalThird}/>
                                2ストライク
                            </label>
                        </div>
                        <div className='search-main-analysis-child-item' style={{ display: 'flex', marginLeft: 10}}>
                            {threeStrike.map(item => {
                                return (
                                    <div key={item.id} className='search-main-advanced-checkbox'>
                                        <label>
                                            <Checkbox checked={item.check} onClick={() => onCheckThird(item.id)}/>
                                            {item.name}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
            </div>
        </div>
    )
}

export default Count;
